module.exports = __webpack_public_path__ + "static/img/logo.6f1edb82.png";